if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSThemeConfig.custom.products_per_page,
			/* Optional */
			loadProductFirst: true,
		},
	};
}
var template_suffix = document.body.getAttribute("data-template-suffix");
let window_url = window.location.href , per_page_limit = boostPFSThemeConfig.custom.products_per_page ;
if(window_url.includes('page')){
	let number_of_pages = window_url.split('page=')[1];
	console.log('number_of_pages',number_of_pages);
	var product_grid_count = per_page_limit * parseInt(number_of_pages-1) ;
}else{
	var product_grid_count = 19;
}
console.log('product_grid_count',product_grid_count);
// Declare Templates
var boostPFSTemplate = {
  // Grid Template
  'productGridItemHtml': '{{promotionItem}}<div id="{{itemHandle}}" data-compare="{{itemcompareprice}}" data-metafield="{{itemmetafield}}" class="grid__item grid-product ' + boostPFSConfig.custom.grid_item_width + ' {{itemQuickShopClass}}" data-aos="row-of-' + boostPFSConfig.custom.products_per_row + '">' +
    '<div class="grid-product__content">' +
    // 									'{{itemSaleLabel}}' +
    '{{itembadgeimage}}' +
    '{{kclot_LG}}' +
    '<div class="grid-product-flash-badge-wrap" style="display:none;">-{{itemFlashbadge}}%</div>' +
    '{{itemSoldOutLabel}}' +
    '{{itemQuickShopButton}}' +
    '<a href="{{itemUrl}}" class="grid-product__link {{itemSoldOutClass}}">' +
    '<div class="grid-product__image-mask">' +
    '{{itemImages}}' +
    '</div>' +
		'</a>' +
    '<div class="grid-product__meta">' +
		'<a href="{{itemUrl}}" class="grid-product__link {{itemSoldOutClass}}">' +
    '<div class="grid-product__title">{{itemTitle}}</div>' +
		'</a>' +
		'<div class="product-review-section"><div class="grid-product__vendor" style="text-transform: none;font-size: 14px; !important">{{vendor}}</div></div>' +
    '{{itemVendor}}' +
		'<div class="collection-popup-form-main-wrap" style="display:none;">' +
		'<div class="collection-popup-form-main-wrap-overlay">' +
		'<div class="collection_popup_details">{{itemvariantpopup}}</div>' +
		'{{itemform}}' +
		'<div class="price-cart-icon-wrap">' +
    '<div class="grid-product__price">{{itemPrice}}</div>' +
		'<div class="collection-popup-detail-main">' +
		'<div class="collection-add-to-cart">{{itemSelectoption}}' +
		'{{itembtnAddtocart}}' +
		'</div>' +
		'</div>' +
		'</div>' +
		'</form>' +
		'</div>' +
		'</div>' +
		'<div class="grid-product-cart-icon-price">' +
		'<div class="grid-product__price">{{itemPrice}}</div>' +
		'<div class="grid-product__cart-icon without-slider-btn" style="margin-bottom:15px;margin-right:5px;"><svg class="icon" style="width: 2em;height: 2em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6906"><path d="M849.066667 349.866667h-115.2c4.266667-25.6 0-51.2-8.533334-81.066667-34.133333-119.466667-157.866667-187.733333-277.333333-157.866667-55.466667 21.333333-102.4 59.733333-132.266667 110.933334-21.333333 38.4-29.866667 85.333333-29.866666 128H174.933333c-17.066667 0-29.866667 12.8-29.866666 34.133333v337.066667c0 115.2 93.866667 213.333333 213.333333 213.333333h200.533333c17.066667 0 34.133333-12.8 34.133334-34.133333s-12.8-34.133333-34.133334-34.133334H354.133333c-81.066667 0-149.333333-68.266667-149.333333-149.333333V413.866667H810.666667v174.933333c0 17.066667 12.8 34.133333 34.133333 34.133333s34.133333-12.8 34.133333-34.133333V384c0-21.333333-12.8-34.133333-29.866666-34.133333z m-179.2 0H354.133333c-4.266667-34.133333 0-68.266667 17.066667-98.133334C392.533333 213.333333 426.666667 187.733333 469.333333 174.933333c85.333333-25.6 174.933333 25.6 196.266667 110.933334 4.266667 21.333333 8.533333 42.666667 4.266667 64z" fill="#080405" p-id="6907"></path><path d="M849.066667 704h-132.266667v-132.266667c0-17.066667-12.8-29.866667-34.133333-29.866666-17.066667 0-29.866667 12.8-29.866667 34.133333v132.266667h-132.266667c-17.066667 0-29.866667 12.8-29.866666 34.133333 0 17.066667 12.8 29.866667 34.133333 29.866667h132.266667v132.266666c0 17.066667 12.8 29.866667 34.133333 29.866667 17.066667 0 29.866667-12.8 29.866667-34.133333V768H853.333333c17.066667 0 29.866667-12.8 29.866667-34.133333-4.266667-17.066667-17.066667-29.866667-34.133333-29.866667z" fill="#1A1311" p-id="6908"></path></svg></div>' +
		
    '<div class="progress-bar flash-sale-progress-bar" style="display:none;">' +	
    '<div class="flash-progressbar-wrap" style="width:{{itemFlashprogress}}%">' +	
    '<div class="flash-progressbar">{{itemFlashprogress}}% sold</div>' +	
    '</div>' +	
    '</div>' +
    '{{itemSwatch}}' +
    '</div>' +
    '<div id="QuickShopModal-{{itemId}}" class="modal modal--square" data-product-id="{{itemId}}"></div>' +
    '</div>',

  // Pagination Template
  'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></a></span>',
  'previousDisabledHtml': '',
  'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></a></span>',
  'nextDisabledHtml': '',
  'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
  'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
  'pageItemRemainHtml': '<span class="deco">...</span>',
  'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

  // Sorting Template
  'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select" class="hidden-label">' + boostPFSConfig.label.sorting + '</label><select class="boost-pfs-filter-top-sorting-select">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/
(function() {
	BoostPFS.inject(this);

	/* some code */
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
	
		if (!data) data = this.data;
		/*** Prepare data ***/
        product_grid_count++;
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

      	itemHtml = itemHtml.replace(/{{itemClassGridItemWidth}}/g, boostPFSConfig.custom.grid_item_width);
      	itemHtml = itemHtml.replace(/{{itemAosProductPerRow}}/g, boostPFSConfig.custom.products_per_row);
		  itemHtml = itemHtml.replace(/{{itemImage}}/g, images[0].src);

		// Get Image size
		var imgSize = '450x650';
		switch (boostPFSConfig.custom.products_per_row) {
			case 5:
				imgSize = '350x550';
				break;
			case 4:
				imgSize = '450x650';
				break;
			case 3:
				imgSize = '450x650';
				break;
			case 2:
				imgSize = '850x1050';
				break;
			case 1:
				imgSize = '1400x1800';
				break;
		}

		// Add Thumbnail
		var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : 1;
		var paddingBottom = images.length > 0 ? 100 / aspectRatio : 100;
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], imgSize) : boostPFSConfig.general.no_image_url;
		var thumb = images.length > 0 ? images[0] : { src: boostPFSConfig.general.no_image_url, width: 500, height: 500 };
		var bgset = buildBgSet(thumb);
		var itemImagesHtml = '';
		if (boostPFSConfig.custom.product_grid_image_size == 'natural') {
			itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">' +
				'<img ' +
				'class="grid-view-item__image lazyload" ' +
				'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
				'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
				'data-aspectratio="' + aspectRatio + '" ' +
				'data-sizes="auto" ' +
				'alt="{{itemTitle}}">' +
				'</div>';
			if (!soldOut) {
				if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
					bgset = buildBgSet(images[1]);
					itemImagesHtml += '<div ' +
                        'name="product_grid_name_pixel" id="{{itemId}}" '+
						'class="grid-product__secondary-image small--hide lazyload"' +
						'data-bgset="' + bgset + '"' +
						'data-sizes="auto">' +
						'</div>';
				}
			}
		} else {
			itemImagesHtml += '<div ' +
				'class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + ' lazyload"' +
				'data-bgset="' + bgset + '"' +
				'data-sizes="auto">' +
				'</div>';
		}

		if (!soldOut) {
			if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
				var bgset = buildBgSet(images[1]);
				itemImagesHtml += '<div ' +
                    'name="product_grid_name_pixel" id="{{itemId}}" '+
					'class="grid-product__secondary-image small--hide lazyload"' +
					'data-bgset="' + bgset + '"' +
					'data-sizes="auto">' +
					'</div>';
			}
		}

		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Price
		var itemPriceHtml = '';
		if (onSale) {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
			itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
		}
		if (priceVaries) {
			itemPriceHtml += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
		} else {
			itemPriceHtml += Utils.formatMoney(data.price_min);
		}
		// if(onSale	){
		// 	var discount_percent;
		// 	discount_percent = Math.round(((data.compare_at_price_min - data.price_min ) * 100.0 ) / data.compare_at_price_min) ;
		// 	itemPriceHtml += `<span class="product-discount-percent">-${discount_percent}%</span>`
		// }
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut Label
		var itemSoldOutLabelHtml = soldOut ? '<div class="grid-product__tag">' + boostPFSConfig.label.sold_out + '</div>' : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

		// Add onSale Label
		var itemSaleLabelHtml = '';
		if (onSale && !soldOut) {
			var savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
			itemSaleLabelHtml = '<div class="grid-product__tag">' + boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice) + '</div>';
		}
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
		
		//add to cart bag
		var itemaadtocartHtml = `<div class="grid-product__cart-icon without-slider-btn" style="margin-bottom:15px;margin-right:5px;"><svg class="icon" style="width: 2em;height: 2em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6906"><path d="M849.066667 349.866667h-115.2c4.266667-25.6 0-51.2-8.533334-81.066667-34.133333-119.466667-157.866667-187.733333-277.333333-157.866667-55.466667 21.333333-102.4 59.733333-132.266667 110.933334-21.333333 38.4-29.866667 85.333333-29.866666 128H174.933333c-17.066667 0-29.866667 12.8-29.866666 34.133333v337.066667c0 115.2 93.866667 213.333333 213.333333 213.333333h200.533333c17.066667 0 34.133333-12.8 34.133334-34.133333s-12.8-34.133333-34.133334-34.133334H354.133333c-81.066667 0-149.333333-68.266667-149.333333-149.333333V413.866667H810.666667v174.933333c0 17.066667 12.8 34.133333 34.133333 34.133333s34.133333-12.8 34.133333-34.133333V384c0-21.333333-12.8-34.133333-29.866666-34.133333z m-179.2 0H354.133333c-4.266667-34.133333 0-68.266667 17.066667-98.133334C392.533333 213.333333 426.666667 187.733333 469.333333 174.933333c85.333333-25.6 174.933333 25.6 196.266667 110.933334 4.266667 21.333333 8.533333 42.666667 4.266667 64z" fill="#080405" p-id="6907"></path><path d="M849.066667 704h-132.266667v-132.266667c0-17.066667-12.8-29.866667-34.133333-29.866666-17.066667 0-29.866667 12.8-29.866667 34.133333v132.266667h-132.266667c-17.066667 0-29.866667 12.8-29.866666 34.133333 0 17.066667 12.8 29.866667 34.133333 29.866667h132.266667v132.266666c0 17.066667 12.8 29.866667 34.133333 29.866667 17.066667 0 29.866667-12.8 29.866667-34.133333V768H853.333333c17.066667 0 29.866667-12.8 29.866667-34.133333-4.266667-17.066667-17.066667-29.866667-34.133333-29.866667z" fill="#1A1311" p-id="6908"></path></svg></div>`;
		//新加载的商品添加到购物车位置去除
		// var itemaadtocartHtml = ``;
		
		itemHtml = itemHtml.replace(/{{itemaadtocart}}/g, itemaadtocartHtml);


		// Add Quick shop
		var itemQuickShopClass = '';
		var itemQuickShopButtonHtml = '';
		if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
			itemQuickShopClass = 'grid-product__has-quick-shop';
			itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide" data-product-id="{{itemId}}">' +
				'<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
				'</div>';
		}
		itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
		itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

		// Build content for Modal
		if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
			var quickUrl = Utils.buildProductItemUrl(data) + '?view=boost-pfs-quickview';
			jQ.ajax({
				url: quickUrl,
				success: function(result) {
					jQ('#QuickShopModal-' + data.id).html(result);

					if (index == totalProduct) {
						theme.initQuickShop();
						AOS.init({
							easing: 'ease-out-quad',
							once: true
						});

						window.sections = new theme.Sections();
						sections.register('product', theme.Product);
						sections.register('product-template', theme.Product);
						sections.register('collection-template', theme.Collection);
					}
				}
			});
		}
		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			var itemReviewsHtml = '';
			if (boostPFSConfig.custom.enable_product_reviews) {
				itemReviewsHtml = '<span class="shopify-product-reviews-badge" data-id="' + data.id + '"></span>';
			}
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
		}

		// Add Swatch
		var itemSwatchHtml = buildSwatch(data, this);
		itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);
		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{vendor}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
        // itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
      	// itemHtml = itemHtml.replace(/{{itemTagClass}}/g, buildTagClass(data));
        // console.log('template_suffix',template_suffix);	
        if(template_suffix == 'flashsale'){	
          if(data.compare_at_price_min){	
            itemHtml = itemHtml.replace(/{{itemcompareprice}}/g, 'true');	
          }	
          // console.log('datametafieldslength',data.metafields.length)	
          if(data.metafields.length > 0){	
            itemHtml = itemHtml.replace(/{{itemmetafield}}/g, 'true');	
          }else{	
            itemHtml = itemHtml.replace(/{{itemmetafield}}/g, 'false');	
          }	
          itemHtml = itemHtml.replace(/{{itemFlashbadge}}/g, buildFlashbadge(data, false));	
          itemHtml = itemHtml.replace(/{{itemFlashprogress}}/g, buildFlashprogress(data, false));	
        }
		itemHtml = itemHtml.replace(/{{itemSelectoption}}/g, buildaddto_select(data));
		itemHtml = itemHtml.replace(/{{itembtnAddtocart}}/g, buildaddtocart_btn(data));	
      
        itemHtml = itemHtml.replace(/{{itembadgeimage}}/g, buildbadge_image(data));
        itemHtml = itemHtml.replace(/{{kclot_LG}}/g, build_shipbadgeimage(data));
      
		itemHtml = itemHtml.replace(/{{itemform}}/g, buildform(data));	
		itemHtml = itemHtml.replace(/{{itemvariantpopup}}/g, build_popdata(data));	

        itemHtml = itemHtml.replace(/{{promotionItem}}/g, build_promotionImage());

		return itemHtml;
	};
  
// collection promotion image
function build_promotionImage(){
	let promotion_item = '' , has_promotionImage = false;
        console.log('template_suffix',template_suffix);
		// if(template_suffix == 'promotion' || template_suffix == '142-8-1' || template_suffix == '195-8' || template_suffix == '232-8' || template_suffix == '251-8' || template_suffix == '259-8'){
          if(typeof myData !== "undefined"){
			myData.forEach(function(item,index){
				if(has_promotionImage) return;
					if(parseInt(item.position) == product_grid_count){
						let item_link ;
						if(item.link != ''){item_link = item.link; }else{item_link = 'javascript:void(0);';}
						promotion_item = `<div class="promotion-grid grid__item small--one-half medium-up--one-quarter grid-promotion"><a href="${item_link}"><div class="grid-product__content"><img src="${item.image}"></div></a></div>`;
						has_promotionImage = true
					}else{
						promotion_item = ``;
					}
			})
		}else{
			promotion_item = ``;
		}
		return promotion_item;
}
  
//collection variantpopup detail
function build_popdata(data){
	var item_popupdata = '', gender_tag ='' , itemprice = '' , item_featureimg , item_option_value = '' ;
	var images = data.images_info;
	item_featureimg =	images[0]['src'];
	if(data.options_with_values[0].name == 'color' || data.options_with_values[0].name == 'colour'){
		item_option_value = data.options_with_values[0].values[0].title;}
	 if(data.tags.includes("GENDER_MEN") && data.tags.includes("GENDER_WOMEN")){
		 gender_tag = "Unisex"
	 }else{
		 if(data.tags.includes("GENDER_MEN")){
			 gender_tag = "Men's"
		 }
		 else if(data.tags.includes("GENDER_WOMEN")){
			 gender_tag = "Women's"
		 }
		 else {
			 gender_tag = "Unisex"
		 }
		}
		
		var priceVaries = data.price_min != data.price_max;
		if (priceVaries) {
			itemprice += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
		} else {
				itemprice += Utils.formatMoney(data.price_min);
		}
	item_popupdata = `<div class="collection-addto_cart_variant_popup"><div class="collection-addto_cart_close"><img src="https://cdn.shopify.com/s/files/1/0535/9527/5424/files/close-icon.png?v=1666005797"></div><div class="collection-popup-left_part"><img src="${item_featureimg}"></div><div class="collection-popup-right_part"><div class="collection-popup-price">${ itemprice }</div><div class="collection-popup-variant_selected_wrap"><span>Selected:</span><span class="collection-popup-color-variant">${ item_option_value }</span><span>,</span><span class="gender_tag">${ gender_tag } </span><span class="collection-popup-size-variant"></span></div></div></div>`;
	
	return item_popupdata;
}
	// collection add to cart form 
	function buildform(data){
		var itemformHtml = '';
		itemformHtml = `<form method="post" action="/cart/add" id="AddToCartForm-${data.id}" accept-charset="UTF-8" class="collection-product-single__form" enctype="multipart/form-data" data-productid="7897690013933"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">`;
		return itemformHtml;
	}

	// Collection add to cart select options
	function buildaddto_select(data){
		var itemaddSelectHtml = '' , itemaddoptionHtml = '' , itemSoldout = ' ' , itemVariantprice ='';
		data.variants.forEach(function(variant){
			if(variant.available){ itemSoldout = '';}else{
				itemSoldout = "data-sold=soldout"
			}
			itemVariantprice = Utils.formatMoney(variant.price);
			itemaddoptionHtml += `<option class="collection-variant-select" ${itemSoldout}                        
                        value="${variant.id}" data-price="${itemVariantprice}" data-variant-title="${variant.title}">
                        ${variant.title}
                      </option>`
		});
		itemaddSelectHtml = `<select name="id" data-productid="${data.id}" id="ProductSelect-${data.id}" class="product-single__variants no-js">${itemaddoptionHtml}</select>`
		return itemaddSelectHtml;
	}

	//add to cart button
	function buildaddtocart_btn(data){
		var item_btn = '' , item_price = '';
		// if((data.empty?) == true ){
		// 	isempty = 'type="button"';
		// }else{
		// 	isempty = 'type="submit"';
		// }
		// item_price = Utils.formatMoney(data.price_max);
		var priceVaries = data.price_min != data.price_max;
		if (priceVaries) {
			item_price += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
		} else {
			item_price += Utils.formatMoney(data.price_min);
		}
		item_btn = `<button type="submit" name="add" id="AddToCart-${ data.id }" class="btn btn--full add-to-cart collection-add-to-cart"><span class="collection-cart_btn">${item_price}</span><span>|</span><span id="AddToCartText-${ data.id }" data-default-text="Add to bag">Add to bag</span></button>`
		return item_btn;
	}

    //badge image display as per collection selected
	function buildbadge_image(data){
		// console.log('badge_product',theme.settings.badge_product);
		// console.log('badge_collection',theme.settings.badge_collection);
		// console.log('badge_image',theme.settings.badge_image);
		// console.log('productttt',data.handle);
		var badge_wrap ;
		var selected_product = theme.settings.badge_product;
		var selected_collection = theme.settings.badge_collection;
		var current_collection = theme.settings.collection;
		var badge_image = theme.settings.badge_image;

		if(selected_product == data.handle){
			badge_wrap = `<div class="image-badge-display"><img src="${badge_image}" height="78px" width="50px"></div>`;
		}else{
			badge_wrap = `<div class="image-badge-display" style="display:none"></div>`;
		}
		if(selected_product != data.handle){
			if(current_collection == selected_collection){
				badge_wrap = `<div class="image-badge-display"><img src="${badge_image}" height="78px" width="50px"></div>`;
			}else{
				badge_wrap = `<div class="image-badge-display" style="display:none"></div>`;
			}
		}
		return badge_wrap;
	}
    function build_shipbadgeimage(data){
		var image_wrap ;
		var kclot_LG_TAG_IMAGE =  theme.settings.ship_badge_image;

		if(data.vendor == 'Kclot-LG' || data.vendor == 'Aporro' ){
			image_wrap = `<div class="image-badge-display"><img src="${kclot_LG_TAG_IMAGE}" height="32px" width="60px"></div>`;
		}else{
			image_wrap= `<div class="image-badge-display" style="display:none"></div>`;
		}
		return image_wrap;
	}
	// Build Swatch
	function buildSwatch(data, ob) {
		var _this = ob;
		var itemSwatchHtml = '';
		if (boostPFSConfig.custom.collection_color_swatches) {
			var swatch_file_extension = 'png';
			var color_count = 0;
			data.options_with_values.forEach(function(option, index) {
				var option_name = option.name.toLowerCase();
				if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
					var option_index = index;
					var values = '';
					itemSwatchHtml += ' <div class="grid-product__colors grid-product__colors--' + data.id + '" >';
					data.variants.forEach(function(variant) {
						var temp = variant.merged_options[option_index].split(':');
						var value = temp[1];
						if (values.indexOf(value) == -1) {
							color_count++;
							values = values + ',' + value;
							values = values.split(',');
							var color_image = Utils.optimizeImage(variant.image, '50px');
							var color_swatch_fallback = value;
							var classImageSwatch = variant.image ? 'color-swatch--with-image color-swatch--small' : 'color-swatch--small';
							var attImage = '';
							if (variant.image) {
								var variant_image = Utils.optimizeImage(variant.image, '400px');
								attImage += 'data-variant-id="' + variant.id + '"';
								attImage += 'data-variant-image="' + variant_image + '"';
							}
							itemSwatchHtml += '<a  href="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '"' + attImage + ' class="color-swatch ' + classImageSwatch + '" style="background-image: url(' + color_image + '); background-color: ' + color_swatch_fallback + ';">';
							itemSwatchHtml += '</a>';
						}
					});
					itemSwatchHtml += '</div>';
				}
			});
			if (color_count < 2) {
				itemSwatchHtml += '<style>.grid-product__colors--' + data.id + ' {display: none;}</style>';
			}
		}
		return itemSwatchHtml;
	}
	/************************** END BUILD PRODUCT LIST **************************/

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	/************************** BUILD TOOLBAR **************************/

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';

		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}

		return html;
	};

	/************************** END BUILD TOOLBAR **************************/

	FilterScrollToTop.prototype.getTemplate = function() {
		return '<a href="javascript:;" aria-label="Back to top" class="boost-pfs-filter-scroll-to-top js-no-transition {{style}}" style="display: inline;">' +
			'<span>Back to top</span>' +
			'</a>';

	}

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data, eventType) {
		AOS.init({
			easing: 'ease-out-quad',
			once: true,
			offset: 60,
			disableMutationObserver: true
		});
		// collection page add to cart popup
		theme.grid_cart_btn();
		theme.grid_add_to_cart_click();
		theme.grid_popup_close();
		theme.grid_popup_on_change();
		if($(window).innerWidth() < 767 ){
			theme.body_click_close();
		}
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	};

       // buildFlashsellprogress function start
    function buildFlashprogress(data, showall) {
      // console.log('dataouttt',data);
        var total_qty = 0 , variant_objArray , metafield_object , metafield_value = 0 ,progress_percent = 0;
        variant_objArray = data.variants;
        let variant_qty = variant_objArray.map(qty => qty.inventory_quantity);
        for (var i = 0 ; i < variant_objArray.length ; i++) {
          total_qty += variant_qty[i];
        } 
        metafield_object = data.metafields;  
        let meta_qty_key = metafield_object.map(meta_key => meta_key.key);
        let meta_qty_value = metafield_object.map(meta_val => meta_val.value);
        for (var i = 0 ; i < metafield_object.length ; i++) {
               if(meta_qty_key[i] == 'product_max_inventory'){
                 metafield_value = meta_qty_value[i];
               }      
        }
        // console.log('total_qty',total_qty);
        // console.log('metafield_value',metafield_value);
        if(total_qty == 0 && metafield_value == 0){
          progress_percent = 0;
        }else{
          progress_percent = Math.round((100 / metafield_value ) * (metafield_value - total_qty)) ;
        }
        // console.log('progress_percent',progress_percent);
        return progress_percent;
    }
    // buildFlashbadge function start
    function buildFlashbadge(data, showall) {
      var discount_percent = ((data.compare_at_price_min - data.price_min) * 100) / data.compare_at_price_min ;
      var percent_round = Math.round(discount_percent);
      var discount_value = percent_round;
      return discount_value;
    }
  
  	// buildTagLabels Function start
  	function buildTagLabels(data, showall) {
      var tagLabel = '';
      if (data.tags) {
        var tagname ='';
        var taglogo= '';
        for (var i = data.tags.length - 1; i >= 0; i--) {
          var tag = data.tags[i];
          tagname ='';
          if (tag == 'Rank_Basic' || tag == 'Rank_Sale' ) {
            tagname = 'Basic';
            taglogo = "https://cdn.shopify.com/s/files/1/0535/9527/5424/files/20220307-175157.png?v=1646650409";
            break;
          }

          if (tag == 'Rank_Designer' || tag == 'Rank_Premium' ) {
            tagname = 'Designer';
            taglogo = "https://cdn.shopify.com/s/files/1/0535/9527/5424/files/20220307-175201.png?v=1646650425";
            break;
          }

          if (tag == 'Rank_Original' || tag == 'Rank_S/P') {
            tagname = 'Original';
            taglogo = "https://cdn.shopify.com/s/files/1/0535/9527/5424/files/20220307-175204.png?v=1646650425" ;
            break;
          }
        }
      }
      if(tagname){
       	tagLabel =  '<span class="tanktagcollection"><span class="tagrankcollectsign">|</span>'+ tagname +'<span class="tagranklogo"><img class="ranklogo" src= ' + taglogo + '></span></span>' ;
      }
        return tagLabel;
    }
  	
	// buildTagClass
  	function buildTagClass(data) {
        var tagLabel = '';
        if (data.tags) {
          var tagClass ='';
          for (var i = data.tags.length - 1; i >= 0; i--) {
            var tag = data.tags[i];
            tagClass ='';
            if (tag == 'Rank_Basic' || tag == 'Rank_Sale' ) {
              	tagClass = 'tagcolsaleclass';
              break;
            }
            
            if (tag == 'Rank_Designer' || tag == 'Rank_Premium') {
              	tagClass = 'tagcolpremiclass';
              break;
            }
            
            if (tag == 'Rank_Original' || tag == 'Rank_S/P') {
              	tagClass = 'tagcolspclass';
              break;
            }
          }
        }
        return tagClass;
    }

  // buildBgSet Function start
	function buildBgSet(image) {
		var html = '';
		if (typeof image !== 'undefined' && image.hasOwnProperty('src')) {
			var aspectRatio = image.width / image.height;
			if (image.width <= 180) html += Utils.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
			if (image.width > 180) html += Utils.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
			if (image.width > 360) html += Utils.optimizeImage(image['src'], '360x') + ' 360w ' + Math.round(360 / aspectRatio) + 'h,';
			if (image.width > 540) html += Utils.optimizeImage(image['src'], '540x') + ' 540w ' + Math.round(540 / aspectRatio) + 'h,';
			if (image.width > 720) html += Utils.optimizeImage(image['src'], '720x') + ' 720w ' + Math.round(720 / aspectRatio) + 'h,';
			if (image.width > 900) html += Utils.optimizeImage(image['src'], '900x') + ' 900w ' + Math.round(900 / aspectRatio) + 'h,';
			if (image.width > 1080) html += Utils.optimizeImage(image['src'], '1080x') + ' 1080w ' + Math.round(1080 / aspectRatio) + 'h,';
			if (image.width > 1296) html += Utils.optimizeImage(image['src'], '1296x') + ' 1296w ' + Math.round(1296 / aspectRatio) + 'h,';
			if (image.width > 1512) html += Utils.optimizeImage(image['src'], '1512x') + ' 1512w ' + Math.round(1512 / aspectRatio) + 'h,';
			if (image.width > 1728) html += Utils.optimizeImage(image['src'], '1728x') + ' 1728w ' + Math.round(1728 / aspectRatio) + 'h,';
		}
		return html;
	}

    // #148582
    jQ(document).on('click','.boost-pfs-filter-option-title',function(e){
      var optClicking = jQ(this).find('button').attr('aria-controls');
      jQ('.boost-pfs-filter-option').each(function(){
        if(jQ(this).find('[aria-controls="'+ optClicking +'"]').length <= 0){
          jQ(this).removeClass('boost-active');
        }
      });
      jQ(this).parent().toggleClass('boost-active');
    });
    // End #148582
  
})();